import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  // 주의: 반드시 중괄호로 감싸 cleanup 반환값을 없앤다.
  // `() => window.scrollTo(0, 0)`로 쓰면 scrollTo의 반환값이 effect의 cleanup으로
  // 등록되는데, scrollTo가 덮여있는 일부 환경(Edge 등)에서 이 값이 함수가 아니면
  // React가 cleanup 호출 시 `destroy is not a function`으로 트리 전체가 크래시한다.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
